import { AB_TESTING_FLAGS } from "@/constants/analytics.constants";
import { useAB } from "@tajawal/web-common/lib";
import { useComputeSplitQueryAttrs } from "./useComputeSplitQueryAttrs";
import _omit from "lodash/omit";

export function usePriceUpfrontAB() {
  const attributes = useComputeSplitQueryAttrs();
  const splitAttributes = _omit(attributes, [
    "origin_iata",
    "destination_iata",
  ]);
  const { active } = useAB(AB_TESTING_FLAGS.PRICE_UPFRONT, splitAttributes);

  return {
    isPriceUpfrontEnabled: active,
  };
}
